import MainBanner from "../../components/mainBanner/mainbanner";
import TopVakancies from "../../topvakancies/topvakancies";
import LastPostedVacancies from "../../components/lastposted/lastposted";
import UsualySearched from "../../components/usualysearched/usualysearched";
import Banners from "../../components/banners/banners";
import Highestpayingjobs from "../../components/Highestpayingjobs/Highestpayingobs";
import CompaniesWorkers from "../../components/companies_workers/companiesworkers";
import News from "../../components/news/news";
import VacancyList from "../../components/likecomponent/likecomponent";
const Home = () => {
  return (
    <>
      <MainBanner />
      <TopVakancies />
      <VacancyList
        fetchUrl="/api//get_vacancy.php"
        titleKey="lastvacansies"
      />

      <section className="w-full p-8 flex justify-between gap-3 items-start max-md:flex-wrap">
        <UsualySearched />
        <Banners type="home" />
      </section>
      <CompaniesWorkers />
      <VacancyList
        fetchUrl="/api/get_highest_salary_vacancies.php"
        titleKey="Highestpayingjobs"
        itemsPerPage={20}
      />

      <News />
    </>
  );
};

export default Home;
